import { render, staticRenderFns } from "./PatientDocumentMsg.vue?vue&type=template&id=a007b398&scoped=true"
import script from "./PatientDocumentMsg.vue?vue&type=script&lang=js"
export * from "./PatientDocumentMsg.vue?vue&type=script&lang=js"
import style0 from "./PatientDocumentMsg.vue?vue&type=style&index=0&id=a007b398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a007b398",
  null
  
)

export default component.exports